// 9fbef606107a605d69c0edbcd8029e5d
/* istanbul ignore file */
import { connect } from 'react-redux';
import PersonalizedCoupons from '../views';
import confirmationSelectors from '../../../container/Confirmation.selectors';

const mapStateToProps = (state) => {
  return {
    couponLoading: confirmationSelectors.getOdmLoading(state),
    coupons: confirmationSelectors.getPersonalizedCoupons(state),
  };
};

export default connect(mapStateToProps)(PersonalizedCoupons);
